<template lang="pug">
.generic-wrapper
  div
    h1.title Angebote erstellen
  
    .two-column.margin-top
      .column.fixed
        h2.title.is-6 Gastdaten
        BookingCustomer(@selectCustomer="(data)=>updateCustomer(data)" ref="bookingCustomer" :existingCustomer="booking.customer" showCreateButton)
        
        ValidationObserver(v-slot="{ handleSubmit }")
          h2.title.is-6 Personen
          b-field(grouped expanded)
            ValidationProvider(name="Erwachsene" rules="required" v-slot="{ errors, valid }") 
              b-field(label="Erwachsene" label-position="on-border"
                      :type="{ 'is-danger': errors[0]}" :message="errors")
                b-select(v-model="booking.adults")
                  option(v-for="a in 8" :value="a-1") {{a-1}} Erwachsene
            .spacer.sm
            ValidationProvider(name="Kinder" rules="required" v-slot="{ errors, valid }") 
              b-field(label="Kinder" label-position="on-border"
                      :type="{ 'is-danger': errors[0]}" :message="errors")
                b-select(v-model="booking.children")
                  option(v-for="c in 8" :value="c-1") {{c-1}} Kinder
          template(v-if="settings.referralList")
            .form
              b-field(label="Woher kommt das Angebot?" label-position="on-border" expanded)
                b-select(v-model="booking.referral" @input="updateBookingSource()" expanded)
                  option(v-for="referralType in settings.referralList.split(',')" :value="referralType") {{referralType}}
      .column.auto
        h2.title.is-6 Preisberechnung
        .offers-wrapper
          .offer-template(v-for="offer, idx in offers")
            //- b-tag(type="is-light")
            //-   b {{offer.rentObject.code}}
            h2.title.is-6 {{offer.rentObject.name}}
            .ot-date {{formatDate(offer.startDate)}} - {{formatDate(offer.endDate)}}
            PriceCalculationTable(
              :rentObjectId="offer.rentObjectId"
              :commissions="commissions"
              :existingCommissionId="offer.commissionId"
              :startDate="offer.startDate"
              :endDate="offer.endDate"
              :persons="personCount"
              :bookingExtras="bookingExtras"
              :existingBookingItems="offer.bookingItems"
              :bookingStatus="offer.bookingStatus"
              @update="(d) => updatePriceData(idx, d)"
            )

    
  .email-wrapper(v-if="offers.length > 0")
    SendMultipleOfferModal(:offers="offers" ref="sendMultipleOffer")
  .container
    .button-wrapper.margin-top.right
      b-button(type="is-light" @click="$router.push({name: 'BookingCalendar'})") Abbrechen
      button.button.is-secondary(@click="showModal()") Speichern ohne Senden
      button.button.is-primary(@click="showModal('sendEmail')") Senden & Speichern
</template>

<script>
import {DateTime} from "luxon"
import PriceCalculationTable from '@/components/molecules/PriceCalculationTable'
import BookingCustomer from '@/components/molecules/BookingCustomer'
import SendMultipleOfferModal from '@/components/molecules/SendMultipleOfferModal'

export default {
  components: {
    PriceCalculationTable,
    BookingCustomer,
    SendMultipleOfferModal
  },
  data() {
    return {
      settings: {},
      showSendOfferModal: false,
      booking: {
        referral: null,
        adults: 1,
        children: 0
      },
      offers: [],
      commissions: null
    };
  },
  watch: {
    personCount() {
      // We update the person count in every offer
      for (let i = 0; i < this.offers.length; i += 1) {
        this.$set(this.offers[i], "adults", this.booking.adults);
        this.$set(this.offers[i], "children", this.booking.children);
      }
    },
    referral() {
      for (let i = 0; i < this.offers.length; i += 1) {
        this.$set(this.offers[i], "referral", this.booking.referral);
      }
    }
  },
  computed: {
    offerSummary() {
      let cheapestPrice = null;
      let mostExpensivePrice = 0;
      let totalPrice = 0;
      let totalCount = 0;

      let earliestArrival = null;
      let latestArrival = null;
      let earliestDeparture = null;
      let latestDeparture = null;

      for (let i = 0; i < this.offers.length; i += 1) {
        totalPrice += this.offers[i].bookingItems.total;
        totalCount += 1;
        if (i === 0) {
          cheapestPrice = this.offers[i].bookingItems.total;
          mostExpensivePrice = this.offers[i].bookingItems.total;
          earliestArrival = this.offers[i].startDate;
          latestArrival = this.offers[i].startDate;
          earliestDeparture = this.offers[i].endDate;
          latestDeparture = this.offers[i].endDate;
        } else {
          if (this.offers[i].bookingItems.total < cheapestPrice) {
            cheapestPrice = this.offers[i].bookingItems.total;
          }
          if (mostExpensivePrice < this.offers[i].bookingItems.total) {
            mostExpensivePrice = this.offers[i].bookingItems.total;
          }
          if (this.offers[i].startDate < earliestArrival) {
            earliestArrival = this.offers[i].startDate;
          }
          if (latestArrival < this.offers[i].startDate) {
            latestArrival = this.offers[i].startDate;
          }
          if (this.offers[i].endDate < earliestDeparture) {
            earliestDeparture = this.offers[i].endDate;
          }
          if (latestDeparture < this.offers[i].endDate) {
            latestDeparture = this.offers[i].endDate;
          }
        }
      }
      const summary = {cheapestPrice: cheapestPrice, mostExpensivePrice, avgPrice: totalPrice / totalCount, earliestArrival, latestArrival, earliestDeparture, latestDeparture};
      return summary;
    },
    bookingStatus() {
      return this.$store.state.bookingStatus.all;
    },
    bookingExtras() {
      return this.$store.state.bookingExtras.all;
    },
    personCount() {
      if (!this.booking) return 0;
      return this.booking.adults + this.booking.children;
    },
    referral() {
      return this.booking.referral;
    },
  },
  async mounted() {
    this.mountBooking();
    this.settings = await this.$store.dispatch("settings/find");
  },
  methods: {
    showModal(sendEmail) {
      this.$refs.bookingCustomer.createCustomer(() => {
        if (this.booking.customer) {
          this.$refs.sendMultipleOffer.sendOffer(sendEmail, () => {
            this.$store.commit('offers/resetSelectedOffers');
            this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.offers[0].startDate).toHTTP(), jumpObjectId: this.offers[0].rentObjectId, bookingStatusId: this.offers[0].bookingStatusId}});
          });
        } else {
          this.$buefy.dialog.alert({
            title: 'Gast fehlt',
            message: 'Sie müssen einen Gast auswählen.',
            type: 'is-warning',
            ariaRole: 'alertdialog',
            ariaModal: true
        })
        }
      });
    },
    async mountBooking() {
      const loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("bookingExtras/findAll");
      await this.$store.dispatch("bookingStatus/findAll");
      this.commissions = await this.$store.dispatch("commissions/findAll");
      
      // It's always an offer when booked on this page/screen
      const status = this.bookingStatus.find(b => b.uuid === "STATUS_BOOKING_OFFER")
      
      // here we select the commission
      const commission = this.commissions.find(c => c.uuid === 'COMMISSION_STANDARD');
      const offers = JSON.parse(JSON.stringify(this.$store.state.offers.selectedOffers));

      // Pro-forma check
      if (offers.length <= 0) {
        this.$router.push({name: 'BookingCalendar'});
      }

      for (let i = 0; i < offers.length; i += 1) {
        this.offers.push({
          rentObject: offers[i].rentObject,
          rentObjectId: offers[i].rentObjectId,
          startDate: DateTime.fromISO(offers[i].startDate),
          endDate: DateTime.fromISO(offers[i].endDate),
          bookingStatusId: status.id,
          bookingStatus: status,
          bookingItems: [],
          commissionId: commission.id,
          createdAt: new Date()
        });

        this.$set(this.offers[i], "adults", this.booking.adults);
        this.$set(this.offers[i], "children", this.booking.children);
      }
      loadingComponent.close();
    },
    updateCustomer(data) {
      this.$set(this.booking, "customer", data);
      this.$set(this.booking, "customerId", data.id);
      
      // We update the customer in every offer
      // this way we can generate multiple offer PDF pages
      for (let i = 0; i < this.offers.length; i += 1) {
        this.$set(this.offers[i], "customer", data);
        this.$set(this.offers[i], "customerId", data.id);
      }
    },
    updatePriceData (idx, data) {
      this.$set(this.offers[idx], "bookingItems", {...data});
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd. LLL. yyyy")
    },
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  .column {
    &.fixed {
      width: 640px;
    }
    &.auto {
      width: calc(100% - 640px);
    }
  }
}
.offers-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-x: auto;
  width: auto;
  border: solid 1px $lightgray;
  border-radius: 3px;
}
.offer-template {
  margin: $sm-space;
  h2 {
    margin: $sm-space 0 $xs-space 0;
  }
  .ot-date {
    margin: 0 0 $sm-space 0;
  }
}
</style>